module.exports = __webpack_public_path__ + "static/media/logo_just_sun.87144979.svg";